import Footer from "./footer";
import Navbar from "./navbar";

const Privacypolicy = () => {
	return (
		<>
			<Navbar />
			{/* <Homecarousel/> */}
			{/* <div className="container-fluid bg-primary py-5 mb-5 page-header">
						<div className="container py-5">
							<div className="row justify-content-center">
								<div className="col-lg-10 text-center">
									<h1 className="display-3 text-white animated slideInDown">
										Disclaimer
									</h1>
									<nav aria-label="breadcrumb">
										<ol className="breadcrumb justify-content-center">
											<li className="breadcrumb-item">
												<a className="text-white" href="index.php">
													Home
												</a>
											</li>
											<li
												className="breadcrumb-item text-white active"
												aria-current="page">
												Disclaimer
											</li>
										</ol>
										<a href="index.php" className="btn btn-success btn-sm">
											Go Back
										</a>
									</nav>
								</div>
							</div>
						</div>
					</div> */}
			<div className="approach-container">
				<div className="approach-inner">
					<h1>Privacy Policy</h1>
					<b>Effective Date: June 1st, 2025</b>

					<div className="approach-content">
						<div className="approach-left">
							<div className="approach-item">
								<p className="approach-description">
									This Privacy Policy outlines how{" "}
									<strong>Krishigap Digital Solutions Pvt. Ltd.</strong>, the
									operator of{" "}
									<a
										target="_blank"
										rel="noreferrer"
										href="https://globalfoodstandards.in/">
										www.globalfoodstandards.in
									</a>
									, collects, uses, and safeguards any information provided by
									users when interacting with this website.
									<br />
									<br />
									Krishigap Digital Solutions Pvt. Ltd. is committed to ensuring
									your privacy is protected. Should we request information that
									may identify you, it will be used strictly in accordance with
									this policy.
									<br />
									<br />
									We may update this policy periodically. Please check this page
									regularly to stay informed of any changes.
								</p>
							</div>

							<div className="approach-item">
								<h3>1. Copyright Policy</h3>
								<ul className="approach-list">
									<li>
										Content on this website may not be reproduced without prior
										written permission. Requests can be sent via email or
										through our contact page.
									</li>
									<li>
										Upon obtaining permission, the material may be used,
										provided that the{" "}
										<strong>
											Global Academy for Food Safety and Sustainability
											Standards
										</strong>{" "}
										is clearly acknowledged as the source.
									</li>
									<li>
										This permission{" "}
										<strong>
											does not apply to third-party copyright material
										</strong>
										, which must be separately obtained by you from the
										respective copyright holders.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>2. Hyperlinking Policy</h3>
								<ul className="approach-list">
									<li>
										External links on our website are provided for convenience.
										We are <strong>not responsible</strong> for the content or
										availability of these linked sites and do not necessarily
										endorse their views.
									</li>
									<li>
										The presence of a link does not imply endorsement or
										approval.
									</li>
									<li>
										For permission to link to our site, including specifying the
										content and hyperlink text, please contact us via the
										Contact Us page.
									</li>
									<li>
										We do not permit our pages to be embedded within frames on
										external sites. All links must open in a new browser window.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>3. Personal Information Collection</h3>
								<p className="approach-description">
									We do not collect personal information unless you voluntarily
									provide it (e.g., via a contact form). If you choose to share
									details such as your name or email address, it will be used
									solely:
								</p>
								<ul className="approach-list">
									<li> To respond to your inquiry</li>
									<li> To provide requested information</li>
									<li> To improve our services (with your consent)</li>
								</ul>
								<p className="approach-description">
									We do not use your data for commercial marketing without your
									explicit consent.
								</p>
							</div>

							<div className="approach-item">
								<h3>4. Types of Information We May Collect</h3>
								<ul className="approach-list">
									<li> Name, job title</li>
									<li> Contact information (email, phone, postal address)</li>
									<li>
										Demographic information (postcode, preferences, interests)
									</li>
									<li> Information relevant to surveys or offers</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>5. Use of Information</h3>
								<p className="approach-description">
									We use collected information for:
								</p>
								<ul className="approach-list">
									<li> Internal records and analysis</li>
									<li> Improving our services and platform</li>
									<li>
										Sending updates and promotional materials (with consent)
									</li>
									<li> Conducting user research or feedback activities</li>
								</ul>
								<p className="approach-description">
									We implement appropriate security measures to prevent
									unauthorized access or disclosure of your data.
								</p>
							</div>

							<div className="approach-item">
								<h3>6. Cookies</h3>
								<p className="approach-description">
									Our website uses cookies to enhance user experience:
								</p>
								<ul className="approach-list">
									<li>
										Cookies help analyze traffic and track website usage to
										tailor services to your preferences.
									</li>
									<li>
										We only use this data for statistical analysis and website
										improvement.
									</li>
									<li>
										Cookies <strong>do not give access to your device</strong>{" "}
										or personal data unless voluntarily provided.
									</li>
									<li>
										You may choose to accept or decline cookies in your browser
										settings.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>7. Managing Your Personal Information</h3>
								<p className="approach-description">
									You may restrict or withdraw consent for the use of your
									personal data:
								</p>
								<ul className="approach-list">
									<li> By unchecking the relevant consent boxes in forms</li>
									<li>
										{" "}
										By contacting us at{" "}
										<strong>
											<a href="mailto:info@krishigap.com">info@krishigap.com</a>
										</strong>
									</li>
									<li>
										Sending updates and promotional materials (with consent)
									</li>
								</ul>
								<p className="approach-description">
									We do <strong>not sell or share</strong> personal information
									with third parties, unless:
								</p>
								<ul className="approach-list">
									<li> Required by law</li>
									<li> You have provided explicit permission</li>
								</ul>
								<p className="approach-description">
									You may request correction or deletion of your data at any
									time.{" "}
									<a href="mailto:info@krishigap.com">info@krishigap.com</a>
								</p>
							</div>

							<div className="approach-item">
								<h3>8. Linking to Our Website</h3>
								<ul className="approach-list">
									<li>
										You may link to our homepage or public pages without prior
										approval, but we request you notify us to receive updates or
										changes.
									</li>
									<li>
										Embedding our site within another site’s frame is not
										permitted. Links must open in a{" "}
										<strong>new browser window</strong>.
									</li>
								</ul>
							</div>

							<div className="approach-item">
								<h3>Contact</h3>
								<p className="approach-description">
									For any concerns regarding this Privacy Policy or the handling
									of your personal data, please contact us at:
									<br />
									📧 <a href="mailto:info@krishigap.com">info@krishigap.com</a>
									<br />
									📍 Krishigap Digital Solutions Pvt. Ltd.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div>
				<Footer />
			</div>
		</>
	);
};

export default Privacypolicy;
